import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";
import UserManagementAvatar from "./UserManagementAvatar";

let columnsData = [
  {
    field: "full_name",
    headerName: "Full Name",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <UserManagementAvatar row={params.row} />
          {params.row.full_name}
        </div>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "mobile_no",
    headerName: "Mobile",
    flex: 1,
    minWidth: 110,
  },
  {
    field: "gender",
    headerName: "Gender",
    flex: 1,
    minWidth: 90,
  },
  {
    field: "role",
    headerName: "Role",
    flex: 1,
    minWidth: 90,
  },
  {
    field: "password",
    headerName: "Password",
    flex: 1,
    minWidth: 90,
  },
];

let actionHeader = (handleDelete, setOpen, setSelectedRow) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      maxWidth: 120,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Edit user"
              onClick={() => {
                setOpen(true);
                setSelectedRow(params.row);
              }}
            >
              <EditRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Delete user"
              onClick={() => handleDelete(params.row)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
